import { Target } from 'data-types-config';
import type { BreadcrumbPatternProps } from './BreadcrumbPattern.types';

export const placeholderBreadcrumbPattern: BreadcrumbPatternProps = {
  text: 'Breadcrumb Item',
  link: '/breadcrumb',
  isCurrent: false,
  target: Target.Self,
};

export const placeholderBreadcrumbPatternList: BreadcrumbPatternProps[] = [
  {
    text: 'Home',
    link: '/',
    isCurrent: false,
    target: Target.Self,
  },
  {
    text: 'Category',
    link: '/category',
    isCurrent: false,
    target: Target.Self,
  },
  {
    text: 'Current Page',
    link: '/category/page',
    isCurrent: true,
    target: Target.Self,
  },
];
